/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![HdIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABK0lEQVR4nN2VO04DMRCGtwEUCXEBDkCXIhUFLZJRdh4uvDMR/XIUFsQFuAIV0KTICWjoQgsFjwJqCiQIshORiF2iVeIIwkh/YY/G3/7rsSZJ/k0451aR5QhIHpF1MIuA5QFZC39WCeATsx6MZRUlwDxfjt9F+lTlYBBTya8BgPUWWHtA8jK2LHd+D1mekfUj5L8k10D6Wh9AehjWJN1xgZyEe2K5BJK3ig5sAOlxVACANpH0DFlPEd3WKH8RD2B1d6LmJtTYTGsDqgJ+AHgZs7+R2qxVG5Cy7AFLHmSz7ekO5N0Ys5ZyZ2chvwhJz/0eUecgGqDddpveHaLaPM9XQiex9qO3qXNu3bsBkqu/8ZJxaQEwHBaxAPcLHThQ9ViHI1OLeZzAtJG5tPEJUXGeD8Ix638AAAAASUVORK5CYII=)
 */
export const HdIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M17.52 13.84c-.4.38-.93.58-1.6.58h-1.19V9.3h1.2c.66 0 1.2.2 1.59.58.39.38.58 1.04.58 1.98s-.2 1.6-.58 1.98Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M5 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H5Zm-.47 14h1.75v-3.42h3.27V16h1.75V7.72H9.55V11H6.28V7.72H4.53V16Zm8.45-8.28V16h2.94c1.26 0 2.22-.36 2.9-1.07.7-.71 1.04-1.73 1.04-3.07 0-1.34-.35-2.36-1.04-3.07-.68-.71-1.64-1.07-2.9-1.07h-2.94Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
